import { z } from 'zod';
import { generateZEnumFromEnum } from '../../utils/forms';
import { ProviderQuestionAnswers } from '../models';

export const getQuestionSchema = () => {
  return z
    .object({
      value: generateZEnumFromEnum(ProviderQuestionAnswers, {
        invalid_type_error: 'Answer is required',
      }).transform((value) => value === ProviderQuestionAnswers.Yes),
      comment: z.string().optional(),
    })
    .refine((data) => !data.value || data.comment, {
      message: 'Comment is required',
      path: ['comment'],
    });
};
